import { Link } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Box } from 'lucide-react'
import {
  sceneFocusFromPath,
  view3dHref,
  type Entitlements,
  type ItemWithPath,
  type LocationPathSegment,
} from '@ousse/shared'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'
import { useHousehold } from '../lib/household'

/** Lien « Voir en 3D » (fly-to) si l'offre et le chemin le permettent. */
export function SeeIn3DLink({
  path,
  locationId,
  itemId,
  className = 'btn secondary',
}: {
  path: ReadonlyArray<LocationPathSegment>
  locationId?: string | null
  itemId?: string
  className?: string
}) {
  const { t } = useTranslation()
  const { me } = useAuth()
  const { current } = useHousehold()
  const simplified = me?.user.simplifiedMode ?? true

  const entitlements = useQuery({
    queryKey: ['entitlements', current?.id],
    enabled: Boolean(current?.id) && !simplified && path.length > 0,
    queryFn: () => api.get<Entitlements>(`/households/${current!.id}/entitlements`),
  })

  if (simplified || !entitlements.data?.features.editor3d) return null
  const focus = sceneFocusFromPath(path, { locationId, itemId })
  if (!focus) return null

  return (
    <Link className={className} to={view3dHref(focus)}>
      <Box aria-hidden size={20} />
      {t('view3d.seeIn3d')}
    </Link>
  )
}

/** Raccourci depuis un ItemWithPath (recherche / fiche). */
export function SeeIn3DForItem({ item }: { item: ItemWithPath }) {
  return <SeeIn3DLink path={item.path} locationId={item.locationId} itemId={item.id} />
}
